import React, { useEffect, useState, useContext, useCallback } from "react";
import { AuthContext } from "../../../context/AuthContext";
import { ENDPOINTS, API_BASE_URL_DOCS } from "../../../config/api";
import "bootstrap/dist/css/bootstrap.min.css";

const Program_files = () => {
  const { authFetch } = useContext(AuthContext);

  const [programas, setProgramas] = useState([]);
  const [selectedProgram, setSelectedProgram] = useState(null);
  const [files, setFiles] = useState([]);

  const [areaUser, setAreaUser] = useState(null);
  const [role, setRole] = useState("");

  const [showModal, setShowModal] = useState(false);

  const [newFile, setNewFile] = useState({
    name: "",
    file: null
  });

  const [formError, setFormError] = useState("");
  const [formSuccess, setFormSuccess] = useState("");

  // FILTROS DE BUSQUEDA
  const [searchName, setSearchName] = useState("");
  const [searchDate, setSearchDate] = useState("");

  // BUSCADOR
  const [searchProgram, setSearchProgram] = useState("");

  // =========================
  // USER
  // =========================
  const fetchUser = useCallback(async () => {
    const data = await authFetch(ENDPOINTS.me);
    if (data.success) {
      setAreaUser(data.user.area);
      setRole(data.user.role);
    }
  }, [authFetch]);

  // =========================
  // PROGRAMAS
  // =========================
  const fetchProgramas = useCallback(async () => {
    const data = await authFetch(ENDPOINTS.get_programasAll);
    if (data.success) {
      setProgramas(data.data || []);
    }
  }, [authFetch]);

  // =========================
  // FILES POR PROGRAMA
  // =========================
  const fetchFiles = async (programId) => {
    const data = await authFetch(
      `${ENDPOINTS.get_program_file}?program=${programId}`
    );

    if (data.success) {
      setFiles(data.data || []);
    }
  };


  // FILTROS DE BUSQUEDA
  const filteredFiles = files.filter((f) => {
  const matchName = f.name_file
    .toLowerCase()
    .includes(searchName.toLowerCase());

  const matchDate = searchDate
    ? f.created_at.startsWith(searchDate)
    : true;

  return matchName && matchDate;
});

  // =========================
  // INIT
  // =========================
  useEffect(() => {
    fetchUser();
    fetchProgramas();
  }, [fetchUser, fetchProgramas]);

  // =========================
  // FILTRO POR AREA
  // =========================
  const rolesFullAccess = ["SuperAdmin", "Director General", "Auditor"];

  const programasFiltrados =
    rolesFullAccess.includes(role)
      ? programas
      : programas.filter(p => Number(p.area) === Number(areaUser));

  

  // PROGRAMA BUSQUEDA
  const programasBusqueda = programasFiltrados.filter((prog) =>
    prog.program_name.toLowerCase().includes(searchProgram.toLowerCase())
  );
  // =========================
  // ABRIR CARPETA
  // =========================
  const handleOpenProgram = (prog) => {
    setSelectedProgram(prog);
    fetchFiles(prog.id);
  };

  // =========================
  // CREAR ARCHIVO
  // =========================
  const handleCreateFile = async () => {

    setFormError("");
    setFormSuccess("");

    if (!newFile.name || !newFile.file) {
      setFormError("Todos los campos son obligatorios");
      return;
    }

    try {

      const formData = new FormData();
      formData.append("program", selectedProgram.id);
      formData.append("name", newFile.name);
      formData.append("file", newFile.file);

      const response = await fetch(ENDPOINTS.create_program_file, {
        method: "POST",
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`
        },
        body: formData
      });

      const data = await response.json();

      if (!data.success) {
        setFormError(data.message);
        return;
      }

      setFormSuccess("Archivo creado correctamente");

      setNewFile({
        name: "",
        file: null
      });

      fetchFiles(selectedProgram.id);

      setTimeout(() => {
        setShowModal(false);
        setFormSuccess("");
      }, 1000);

    } catch (error) {
      console.error(error);
      setFormError("Error al conectar con el servidor");
    }
  };

  return (
    <div className="container mt-4 p-4">

      {/* ========================= */}
      {/* LISTA DE PROGRAMAS */}
      {/* ========================= */}
      {!selectedProgram && (
        <>
          <h3 className="mb-4">Programas</h3>

          <div className="row mb-4">
            <div className="col-md-6">
              <input
                type="text"
                className="form-control"
                placeholder="Buscar documentos por programa..."
                value={searchProgram}
                onChange={(e) => setSearchProgram(e.target.value)}
              />
            </div>
          </div>

          <div className="row">
            {programasBusqueda.map((prog) => (
              <div key={prog.id} className="col-md-3 mb-4">
                <div
                  className="card shadow-sm p-3 text-center"
                  style={{ cursor: "pointer" }}
                  onClick={() => handleOpenProgram(prog)}
                >
                  <div style={{ fontSize: "40px" }}>📁</div>
                  <strong>{prog.program_name}</strong>
                  <small className="text-muted">{prog.area_name}</small>
                </div>
              </div>
            ))}
          </div>
        </>
      )}

      {/* ========================= */}
      {/* VISTA INTERNA */}
      {/* ========================= */}
      {selectedProgram && (
        <>
          <div className="position-relative d-flex align-items-center mb-3">

            {/* IZQUIERDA */}
            <button
              className="btn btn-outline-purple"
              onClick={() => setSelectedProgram(null)}
            >
              <i className="bi bi-arrow-left"></i>
            </button>

            {/* CENTRO */}
            <h4 className="position-absolute start-50 translate-middle-x mb-0">
              📁 {selectedProgram.program_name}
            </h4>

            {/* DERECHA */}
            <button
              className="btn btn-outline-pink ms-auto"
              onClick={() => setShowModal(true)}
            >
              <i className="bi bi-plus me-2"></i> Crear archivo
            </button>

          </div>

          {/* FILTROS DE BUSQUEDA */}
          <div className="row mb-3">
            <div className="col-md-6">
              <input
                type="text"
                className="form-control"
                placeholder="Buscar por nombre..."
                value={searchName}
                onChange={(e) => setSearchName(e.target.value)}
              />
            </div>

            <div className="col-md-6">
              <input
                type="month"
                className="form-control"
                value={searchDate}
                onChange={(e) => setSearchDate(e.target.value)}
              />
            </div>
          </div>

          <ul className="list-group mt-4">
            {filteredFiles.length > 0 ? (
              filteredFiles.map((f, i) => {
                const fileUrl = `${API_BASE_URL_DOCS}${f.file_path}`;

                return (
                  <li key={i} className="list-group-item d-flex justify-content-between align-items-center">
                    <div>
                      <i className="bi bi-file-earmark me-2"></i>
                      <strong>{f.name_file}</strong>
                      <br />
                      <small className="text-muted">{f.created_at}</small>
                    </div>

                    <a
                      href={fileUrl}
                      target="_blank"
                      rel="noreferrer"
                      className="btn btn-sm btn-outline-pink"
                    >
                      Ver
                    </a>
                  </li>
                );
              })
            ) : (
              <li className="list-group-item text-center text-muted py-4">
                <i className="bi bi-folder-x me-2"></i>
                No hay archivos
              </li>
            )}
          </ul>
        </>
      )}

      {/* ========================= */}
      {/* MODAL */}
      {/* ========================= */}
      {showModal && (
        <div className="modal show d-block">
          <div className="modal-dialog">
            <div className="modal-content">

              <div className="modal-header">
                <h5>Crear Archivo</h5>
                <button className="btn-close" onClick={() => setShowModal(false)} />
              </div>

              <div className="modal-body">

                {formError && (
                  <div className="alert alert-danger">{formError}</div>
                )}

                {formSuccess && (
                  <div className="alert alert-success">{formSuccess}</div>
                )}

                <input
                  type="text"
                  className="form-control mb-3"
                  placeholder="Nombre del archivo"
                  value={newFile.name}
                  onChange={(e) =>
                    setNewFile({ ...newFile, name: e.target.value })
                  }
                />

                <input
                  type="file"
                  className="form-control"
                  onChange={(e) =>
                    setNewFile({ ...newFile, file: e.target.files[0] })
                  }
                />
              </div>

              <div className="modal-footer">
                <button
                  className="btn btn-outline-secondary"
                  onClick={() => setShowModal(false)}
                >
                  Cancelar
                </button>

                <button
                  className="btn btn-outline-pink"
                  onClick={handleCreateFile}
                >
                  Guardar
                </button>
              </div>

            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Program_files;